<template>
  <div class="filiais-selector-wrapper">
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        :offset-y="!isMobile"
        :offset-x="false"
        :max-width="isMobile ? '95vw' : '600'"
        :min-width="isMobile ? '95vw' : '580'"
        :content-class="isMobile ? 'mobile-menu' : ''"
        :nudge-bottom="isMobile ? 0 : 10"
        :top="isMobile"
        :bottom="!isMobile"
        :attach="isMobile ? 'body' : false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            :value="displayFiliais"
            placeholder="Selecione as filiais"
            prepend-inner-icon="mdi-domain"
            readonly
            dense
            outlined
            hide-details
            :disabled="disabled"
            :loading="loading"
            class="filiais-field"
            v-bind="attrs"
            v-on="on"
            :clearable="clearable"
            @click:clear="limparSelecao"
            :label="label"
        >
          <template v-slot:append v-if="value.length > 0 && showCheckIcon">
            <v-icon :color="checkIconColor">mdi-check-circle</v-icon>
          </template>
        </v-text-field>
      </template>

      <v-card class="filiais-menu-card" :class="{ 'mobile-card': isMobile }">
        <!-- Header Mobile -->
        <v-card-title v-if="isMobile" class="mobile-header">
          <div class="mobile-header-content">
            <v-icon color="white" small>mdi-domain</v-icon>
            <span class="mobile-header-title">Selecionar Filiais</span>
          </div>
          <v-btn icon small color="white" @click="fecharModal">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Conteúdo -->
        <div class="filiais-content" :class="{ 'mobile-content': isMobile }">
          <!-- Atalhos Rápidos Compactos -->
          <template v-if="exibirAtalhos">
            <v-card-text class="py-2 px-3 atalhos-section">
              <div class="atalhos-grid">
                <v-btn
                    v-if="atalhoHabilitado('todas')"
                    x-small
                    outlined
                    :color="atalhoAtivo === 'todas' ? 'primary' : '#023449'"
                    :class="{ 'atalho-ativo': atalhoAtivo === 'todas' }"
                    @click="selecionarAtalho('todas')"
                    :disabled="disabled"
                    class="atalho-btn"
                >
                  <v-icon x-small left>mdi-checkbox-multiple-marked</v-icon>
                  Todas
                </v-btn>

                <v-btn
                    v-if="atalhoHabilitado('minha')"
                    x-small
                    outlined
                    :color="atalhoAtivo === 'minha' ? 'primary' : '#023449'"
                    :class="{ 'atalho-ativo': atalhoAtivo === 'minha' }"
                    @click="selecionarAtalho('minha')"
                    :disabled="disabled"
                    class="atalho-btn"
                >
                  <v-icon x-small left>mdi-account-circle</v-icon>
                  Minha Loja
                </v-btn>

                <v-btn
                    v-if="atalhoHabilitado('lojas')"
                    x-small
                    outlined
                    :color="atalhoAtivo === 'lojas' ? 'primary' : '#023449'"
                    :class="{ 'atalho-ativo': atalhoAtivo === 'lojas' }"
                    @click="selecionarAtalho('lojas')"
                    :disabled="disabled"
                    class="atalho-btn"
                >
                  <v-icon x-small left>mdi-storefront</v-icon>
                  Lojas
                </v-btn>

                <v-btn
                    v-if="temDepositos && atalhoHabilitado('depositos')"
                    x-small
                    outlined
                    :color="atalhoAtivo === 'depositos' ? 'primary' : '#023449'"
                    :class="{ 'atalho-ativo': atalhoAtivo === 'depositos' }"
                    @click="selecionarAtalho('depositos')"
                    :disabled="disabled"
                    class="atalho-btn"
                >
                  <v-icon x-small left>mdi-warehouse</v-icon>
                  Depósitos
                </v-btn>

                <v-btn
                    v-if="temCDs && atalhoHabilitado('cd')"
                    x-small
                    outlined
                    :color="atalhoAtivo === 'cd' ? 'primary' : '#023449'"
                    :class="{ 'atalho-ativo': atalhoAtivo === 'cd' }"
                    @click="selecionarAtalho('cd')"
                    :disabled="disabled"
                    class="atalho-btn"
                >
                  <v-icon x-small left>mdi-truck-delivery</v-icon>
                  CD
                </v-btn>
              </div>
            </v-card-text>

            <v-divider></v-divider>
          </template>

          <!-- Busca Compacta -->
          <v-card-text class="py-2 px-3 busca-section">
            <v-text-field
                v-model="busca"
                placeholder="Buscar..."
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                autofocus
                ref="campoBusca"
                class="busca-field"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Lista de Filiais Compacta -->
          <div class="filiais-list-wrapper">
            <v-virtual-scroll
                :items="filiaisFiltradas"
                :height="isMobile ? listHeightMobile : 280"
                :item-height="isMobile ? 45 : 49"
            >
              <template v-slot:default="{ item }">
                <div class="filial-item-wrapper">
                  <v-list-item
                      dense
                      @click="toggleFilial(item)"
                      :class="{ 'filial-selecionada': filialSelecionada(item) }"
                      class="filial-item"
                  >
                    <v-list-item-action v-if="!single" class="mr-2 my-0">
                      <v-checkbox
                          :input-value="filialSelecionada(item)"
                          color="#023449"
                          hide-details
                          dense
                          @click.stop="toggleFilial(item)"
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content class="py-1">
                      <v-list-item-title class="filial-nome">
                        {{ item.filial }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="filial-info">
                        Cód: {{ item.idfilial }} • {{ item.endereco }}, {{ item.numero }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action v-if="item.deposito || item.cd" class="my-0 ml-1">
                      <v-chip
                          x-small
                          outlined
                          :color="item.cd ? '#0369a1' : '#10b981'"
                          class="tipo-chip"
                      >
                        {{ item.cd ? 'CD' : 'DEP' }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="item-divider"></v-divider>
                </div>
              </template>
            </v-virtual-scroll>
          </div>
        </div>

        <!-- Footer Compacto (oculto no modo single) -->
        <template v-if="!single">
        <v-divider></v-divider>
        <v-card-actions class="py-2 px-3 menu-footer">
          <div class="d-flex align-center">
            <v-chip
                v-if="selecaoInterna.length > 0"
                x-small
                outlined
                color="#023449"
                class="count-chip"
            >
              <v-icon x-small left>mdi-check-circle</v-icon>
              {{ selecaoInterna.length }} selecionada{{ selecaoInterna.length > 1 ? 's' : '' }}
            </v-chip>
            <span v-else class="text-empty">Nenhuma selecionada</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
              x-small
              text
              color="error"
              @click="limparSelecaoInterna"
              :disabled="disabled || selecaoInterna.length === 0"
              class="action-btn"
          >
            <v-icon x-small left>mdi-close-circle</v-icon>
            Limpar
          </v-btn>
          <v-btn
              x-small
              color="primary"
              depressed
              @click="aplicarSelecao"
              :disabled="disabled"
              class="action-btn-primary"
          >
            <v-icon x-small left>mdi-check</v-icon>
            Aplicar
          </v-btn>
        </v-card-actions>
        </template>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'SeletorFiliais',

  props: {
    value: {
      type: Array,
      default: () => []
    },
    filiais: {
      type: Array,
      default: () => []
    },
    minhaFilial: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    showCheckIcon: {
      type: Boolean,
      default: true
    },
    checkIconColor: {
      type: String,
      default: 'success'
    },
    // Controla quais atalhos rápidos exibir. Passe [] para ocultar todos.
    shortcuts: {
      type: Array,
      default: () => ['todas', 'minha', 'lojas', 'depositos', 'cd'],
      validator: (value) => {
        const validos = ['todas', 'minha', 'lojas', 'depositos', 'cd']
        return value.every(v => validos.includes(v))
      }
    },
    // Permite limpar a seleção pelo ícone X no campo
    clearable: {
      type: Boolean,
      default: true
    },
    // Restringe a seleção a uma única filial por vez
    single: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      menu: false,
      busca: '',
      selecaoInterna: [],
      windowWidth: window.innerWidth
    }
  },

  computed: {
    isMobile() {
      return this.windowWidth < 960
    },

    listHeightMobile() {
      const viewportHeight = window.innerHeight
      const usedSpace = 250
      return Math.max(200, viewportHeight * 0.85 - usedSpace)
    },

    filiaisDisponiveis() {
      return this.filiais || []
    },

    // Verifica se deve exibir a seção de atalhos
    exibirAtalhos() {
      return this.shortcuts && this.shortcuts.length > 0
    },

    displayFiliais() {
      if (this.value.length === 0) return ''

      if (this.value.length === 1) {
        const filial = this.filiaisDisponiveis.find(f => f.idfilial === this.value[0])
        return filial ? filial.filial : ''
      }

      if (this.value.length === this.filiaisDisponiveis.length) {
        return 'Todas as filiais'
      }

      const primeira = this.filiaisDisponiveis.find(f => f.idfilial === this.value[0])
      return primeira
          ? `${primeira.filial} (+${this.value.length - 1})`
          : `${this.value.length} filiais selecionadas`
    },

    filiaisFiltradas() {
      if (!this.busca) {
        return this.filiaisDisponiveis
      }

      const termo = this.busca.toLowerCase()
      return this.filiaisDisponiveis.filter(f => {
        return (
            f.filial.toLowerCase().includes(termo) ||
            f.endereco.toLowerCase().includes(termo) ||
            f.bairro.toLowerCase().includes(termo) ||
            String(f.idfilial).includes(termo)
        )
      })
    },

    temDepositos() {
      return this.filiaisDisponiveis.some(f => f.deposito === true)
    },

    temCDs() {
      return this.filiaisDisponiveis.some(f => f.cd === true)
    },

    atalhoAtivo() {
      const selecionados = this.selecaoInterna

      if (selecionados.length === this.filiaisDisponiveis.length && selecionados.length > 0) {
        return 'todas'
      }

      if (selecionados.length === 1 && selecionados[0] === this.minhaFilial) {
        return 'minha'
      }

      const lojas = this.filiaisDisponiveis
          .filter(f => !f.deposito && !f.cd)
          .map(f => f.idfilial)

      if (
          lojas.length > 0 &&
          selecionados.length === lojas.length &&
          selecionados.every(id => lojas.includes(id))
      ) {
        return 'lojas'
      }

      const depositos = this.filiaisDisponiveis
          .filter(f => f.deposito === true)
          .map(f => f.idfilial)

      if (
          depositos.length > 0 &&
          selecionados.length === depositos.length &&
          selecionados.every(id => depositos.includes(id))
      ) {
        return 'depositos'
      }

      const cds = this.filiaisDisponiveis
          .filter(f => f.cd === true)
          .map(f => f.idfilial)

      if (
          cds.length > 0 &&
          selecionados.length === cds.length &&
          selecionados.every(id => cds.includes(id))
      ) {
        return 'cd'
      }

      return null
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selecaoInterna = [...newVal]
      }
    },

    menu(opened) {
      if (opened) {
        this.selecaoInterna = [...this.value]
        this.busca = ''
        this.focarBusca()

        if (this.isMobile) {
          document.body.style.overflow = 'hidden'
        }
      } else {
        if (this.isMobile) {
          document.body.style.overflow = ''
        }
      }
    }
  },

  methods: {
    // o conteúdo do menu só existe depois de aberto; o autofocus cobre a 1ª abertura e este foco as seguintes
    focarBusca() {
      setTimeout(() => {
        const campo = this.$refs.campoBusca
        if (campo && campo.focus) campo.focus()
      }, 50)
    },

    handleResize() {
      this.windowWidth = window.innerWidth
    },

    // Verifica se um atalho específico está habilitado
    atalhoHabilitado(atalho) {
      return this.shortcuts.includes(atalho)
    },

    filialSelecionada(filial) {
      return this.selecaoInterna.includes(filial.idfilial)
    },

    toggleFilial(filial) {
      if (this.single) {
        // Seleção única: alterna entre selecionar e desselecionar
        const jaSelecionada = this.selecaoInterna.includes(filial.idfilial)
        this.selecaoInterna = jaSelecionada ? [] : [filial.idfilial]
        if (!jaSelecionada) this.aplicarSelecao()
        return
      }

      const index = this.selecaoInterna.indexOf(filial.idfilial)
      if (index > -1) {
        this.selecaoInterna.splice(index, 1)
      } else {
        this.selecaoInterna.push(filial.idfilial)
      }
    },

    selecionarAtalho(atalho) {
      this.busca = ''

      switch (atalho) {
        case 'todas':
          this.selecaoInterna = this.filiaisDisponiveis.map(f => f.idfilial)
          break

        case 'minha':
          if (this.minhaFilial) {
            this.selecaoInterna = [this.minhaFilial]
          }
          break

        case 'lojas':
          this.selecaoInterna = this.filiaisDisponiveis
              .filter(f => !f.deposito && !f.cd)
              .map(f => f.idfilial)
          break

        case 'depositos':
          this.selecaoInterna = this.filiaisDisponiveis
              .filter(f => f.deposito === true)
              .map(f => f.idfilial)
          break

        case 'cd':
          this.selecaoInterna = this.filiaisDisponiveis
              .filter(f => f.cd === true)
              .map(f => f.idfilial)
          break
      }
    },

    limparSelecaoInterna() {
      this.selecaoInterna = []
    },

    limparSelecao() {
      this.selecaoInterna = []
      this.$emit('input', [])
      this.$emit('change', [])
      this.$emit('clear')
    },

    aplicarSelecao() {
      this.$emit('input', this.selecaoInterna)
      this.$emit('change', this.selecaoInterna)
      this.$emit('apply', this.selecaoInterna)
      this.menu = false
    },

    fecharModal() {
      this.menu = false
    }
  }
}
</script>

<style scoped>
/* ===== WRAPPER ===== */
.filiais-selector-wrapper {
  width: 100%;
}

/* ===== INPUT ===== */
.filiais-field >>> .v-input__control {
  min-height: 44px !important;
}

.filiais-field >>> fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
  transition: all 0.2s ease;
}

.filiais-field >>> .v-input__slot {
  background: #f8fafc;
  transition: all 0.2s ease;
  border-radius: 10px;
}

.filiais-field >>> .v-input__prepend-inner .v-icon,
.filiais-field >>> .v-input__append .v-icon {
  color: #023449 !important;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.filiais-field:hover >>> .v-input__prepend-inner .v-icon,
.filiais-field:hover >>> .v-input__append .v-icon {
  opacity: 1 !important;
}

.filiais-field >>> .v-input__slot:hover {
  background: #ffffff;
}

.filiais-field >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}

.filiais-field >>> .v-input--is-focused fieldset {
  border-color: #023449 !important;
  border-width: 2px;
  box-shadow: 0 0 0 3px rgba(2, 52, 73, 0.1);
}

.filiais-field >>> .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

/* ===== MENU CARD ===== */
.filiais-menu-card {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(2, 52, 73, 0.15) !important;
  overflow: hidden;
}

.mobile-card {
  max-width: 95vw !important;
  width: 95vw !important;
  max-height: 85vh !important;
  display: flex;
  flex-direction: column;
}

/* ===== HEADER MOBILE ===== */
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: linear-gradient(135deg, #023449 0%, #035a7a 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.2);
  flex-shrink: 0;
}

.mobile-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-header-title {
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

/* ===== CONTEÚDO ===== */
.filiais-content {
  display: flex;
  flex-direction: column;
  height: auto;
}

.mobile-content {
  max-height: calc(85vh - 92px);
  min-height: 0;
  flex: 1;
  overflow: hidden;
}

.atalhos-section,
.busca-section {
  flex-shrink: 0;
}

/* ===== ATALHOS COMPACTOS ===== */
.atalhos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  gap: 4px;
}

.atalho-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0;
  font-size: 0.65rem !important;
  height: 26px !important;
  min-width: 85px !important;
  border-radius: 6px;
  transition: all 0.2s ease;
  border-width: 1.5px !important;
  padding: 0 8px !important;
}

.atalho-btn >>> .v-icon {
  font-size: 14px !important;
}

.atalho-btn:hover:not(.v-btn--disabled) {
  background-color: #023449 !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.2);
}

.atalho-ativo {
  background-color: #023449 !important;
  color: #ffffff !important;
  font-weight: 700;
}

/* ===== BUSCA COMPACTA ===== */
.busca-field >>> .v-input__control {
  min-height: 36px !important;
}

.busca-field >>> fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
}

.busca-field >>> .v-input__slot {
  background: #f8fafc;
  border-radius: 8px;
  min-height: 36px !important;
}

.busca-field >>> .v-text-field__details {
  display: none;
}

.busca-field >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}

.busca-field >>> .v-input--is-focused fieldset {
  border-color: #023449 !important;
}

/* ===== LISTA DE FILIAIS COMPACTA ===== */
.filiais-list-wrapper {
  background: #ffffff;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.filial-item-wrapper {
  background: #ffffff;
}

.filial-item {
  transition: background-color 0.2s ease;
  cursor: pointer;
  min-height: 48px !important;
  max-height: 48px !important;
  padding: 4px 12px !important;
  background: #ffffff !important;
}

.filial-item:hover {
  background-color: rgba(2, 52, 73, 0.04) !important;
}

.filial-selecionada {
  background-color: rgba(2, 52, 73, 0.06) !important;
}

.item-divider {
  margin: 0 !important;
  border-color: #e2e8f0 !important;
}

.filial-item >>> .v-list-item__action {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.filial-nome {
  font-size: 0.813rem;
  font-weight: 600;
  color: #023449;
  line-height: 1.2;
}

.filial-info {
  font-size: 0.688rem;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.2;
}

.tipo-chip {
  font-weight: 700;
  font-size: 0.625rem;
  border-width: 1.5px !important;
  height: 18px !important;
}

/* ===== FOOTER COMPACTO ===== */
.menu-footer {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  min-height: 44px !important;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.count-chip {
  font-weight: 600;
  border-width: 1.5px !important;
  height: 20px !important;
  font-size: 0.688rem;
}

.text-empty {
  font-size: 0.688rem;
  color: #94a3b8;
  font-style: italic;
}

.action-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0;
  border-radius: 6px;
  height: 28px !important;
  font-size: 0.688rem !important;
  padding: 0 10px !important;
  transition: all 0.2s ease;
}

.action-btn:hover:not(.v-btn--disabled) {
  background-color: rgba(220, 38, 38, 0.08) !important;
  color: #dc2626 !important;
}

.action-btn-primary {
  text-transform: none !important;
  font-weight: 700 !important;
  letter-spacing: 0;
  border-radius: 6px;
  height: 28px !important;
  font-size: 0.688rem !important;
  padding: 0 12px !important;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.2);
  transition: all 0.2s ease;
  background-color: #023449 !important;
  color: #ffffff !important;
}

.action-btn-primary:hover:not(.v-btn--disabled) {
  box-shadow: 0 4px 12px rgba(2, 52, 73, 0.3);
  transform: translateY(-1px);
  background-color: #035a7a !important;
}

.action-btn-primary >>> .v-btn__content {
  color: #ffffff !important;
}

.action-btn-primary >>> .v-icon {
  color: #ffffff !important;
}

/* ===== SCROLLBAR ===== */
.filiais-list-wrapper::-webkit-scrollbar {
  width: 3px;
}

.filiais-list-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.filiais-list-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.filiais-list-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ===== MENU MOBILE ===== */
.mobile-menu {
  position: fixed !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  max-width: 95vw !important;
  max-height: 85vh !important;
}

/* ===== RESPONSIVIDADE TABLET ===== */
@media (max-width: 960px) and (min-width: 600px) {
  .atalhos-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 599px) {
  .mobile-header {
    padding: 8px 10px;
  }

  .mobile-header-title {
    font-size: 0.813rem;
  }

  .atalhos-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .atalho-btn {
    min-width: auto !important;
    font-size: 0.625rem !important;
    height: 28px !important;
  }

  .busca-section {
    padding: 8px 10px !important;
  }

  .filial-item {
    min-height: 44px !important;
    max-height: 44px !important;
    padding: 4px 10px !important;
  }

  .filial-nome {
    font-size: 0.75rem;
  }

  .filial-info {
    font-size: 0.625rem;
  }

  .menu-footer {
    padding: 6px 10px !important;
  }

  .count-chip {
    font-size: 0.625rem;
  }

  .text-empty {
    font-size: 0.625rem;
  }

  .action-btn {
    font-size: 0.625rem !important;
    height: 26px !important;
    padding: 0 8px !important;
  }

  .action-btn-primary {
    font-size: 0.625rem !important;
    height: 26px !important;
    padding: 0 10px !important;
  }
}

/* ===== LANDSCAPE MOBILE ===== */
@media (max-width: 960px) and (orientation: landscape) {
  .mobile-content {
    max-height: 80vh;
  }
}

/* ===== TELAS MUITO PEQUENAS ===== */
@media (max-width: 360px) {
  .atalhos-grid {
    gap: 4px;
  }

  .atalho-btn {
    font-size: 0.563rem !important;
    height: 26px !important;
    padding: 0 6px !important;
  }

  .atalho-btn >>> .v-icon {
    font-size: 12px !important;
  }

  .filial-nome {
    font-size: 0.688rem;
  }

  .filial-info {
    font-size: 0.563rem;
  }

  .action-btn-primary {
    font-size: 0.625rem !important;
    height: 26px !important;
    padding: 0 10px !important;
  }
}

/* ===== ACESSIBILIDADE ===== */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>